declare global {
  interface Window {
    __env__?: {
      API_URL: string;
      BASE_URL: string;
      ENVIRONMENT: string;
      DOCKER_IMAGE_TAG: string;
    };
  }
}

export const API_URL = window.__env__?.API_URL ?? '';
export const BASE_URL = window.__env__?.BASE_URL ?? '';
export const ENVIRONMENT = window.__env__?.ENVIRONMENT;
export const DOCKER_IMAGE_TAG = window.__env__?.DOCKER_IMAGE_TAG ?? '';

export const API_VERSION = '/v1';
export const BASE_API_URL = `${API_URL}${API_VERSION}/image-app`;
